import React from 'react';
import './Styles/Container.scss';
import {ReactComponent as Logo} from '../../../Assets/Cards/monzo.svg';
import { cardsData, numberList, sectionsData1, sectionsData2, sectionsData3 } from './data';
import Card from '../../Shared/Cards/CustomerCard/Card';
import Section from './Section';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import { Link } from 'react-router-dom';
const Container=()=>{
    return(
        <div className="monzo-container">
            <div className="content">
                <h1>Building the bank of the future — How Hostdesign keeps Monzo shipping every two weeks</h1>
                <Logo />
                <div className="numbers">
                    <ul>
                        {numberList.map((item) =>{
                            return(
                                <li>
                                    <h1>{item.number}</h1>
                                    <h3>{item.title}</h3>
                                    <p>{item.desc}</p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                {sectionsData1.map((d) =>{
                    return(
                        <Section {...d} />
                    )
                })}
                <h1>“Hostdesign lets you see round the corner. Whenever we have a new idea or different direction for something, Hostdesign comes with us. We can show people what the future looks like using Hostdesign.”</h1>
                {sectionsData2.map((d) =>{
                    return(
                        <Section {...d} />
                    )
                })}
                <div className="images">
                    <div className="image-part part1"></div>
                    <div className="image-part part2"></div>

                </div>
                {sectionsData3.map((d) =>{
                    return(
                        <Section {...d} />
                    )
                })}
                <h1>“It doesn’t get in the way. This is something that’s very important to us. We don’t like add-ons or overheads. It gives us control.”</h1>
                <Section 
                desc="That control has allowed the team to operate at a pace that a high street bank could only dream of. “We are getting faster and faster. In the beginning we were 13 members of staff, we are now 220. Our design team has gone from just me to 6 people in that time, too.”"
                />
                <Section 
                desc="Hostdesign has allowed new designers and members of staff to onboard into the fast-paced workflow Monzo is accustomed to within hours, rather than days."
                />
                <div className="image-detail"></div>
                <Section desc="Previously, to showcase new features to shareholders and the community, Hugo and his team would make videos and presentation decks. Hostdesign changed that." />
                <h1>Previously, to showcase new features to shareholders and the community, Hugo and his team would make videos and presentation decks. Hostdesign changed that.</h1>
                <Section desc="It’s this tactile sense of a product, rather than just passively consuming content that has brought Monzo’s customers closer to the company than many thought possible. In fact, part of Monzo’s workflow involves working with its community to come up with new features and test out ideas."/>
                <Section desc="That relationship has lead to user testing sessions with customers every two weeks, with Marvel being at the heart of that iterative process."/>
                <h1>“We use Hostdesign a lot to show our customers what we’re working on next. They can then give us feedback, make new suggestions. It’s incredible. Hostdesign lets you see round the corner. Whenever we have a new idea or different direction for something, Hostdesign comes with us.”</h1>
            </div>
            <div className="cards">
                {cardsData.map((d) =>{
                    return(
                        <Card {...d}/>
                    )
                })}
                <Link to="/customer-stories">
              <StyledButton btn="View all stories" styles="nobg-btn"/>
              </Link>
            </div>
        </div>
    )
};
export default Container ;